<template>
  <div class="stop-selector">
    <div class="stop-selector__searcher">
      <div class="location-selector-container">
        <RCSelect
          class="stop-selector__country"
          label="Country"
          :suggestions="countryCodes"
          v-model="selectedCountryCode"
          @change="resetSearcherInfo"
          :defaultValue="'US'"
          :key="renderKey"
        />
        <b-overlay class="stop-selector__spinner" :show="loading" rounded="sm">
          <!-- NEW SELECT AUTO COMPLETE -->
          <AutoComplete
            :label="computedLabelPickup"
            :suggestions="filteredStops"
            :requestLength="isPortStop ? 0 : 3"
            :forceSelection="true"
            :requiredField="true"
            :loading="loadingAutoComplete"
            :missingField="emptyFields['stopData'] === true"
            :disabled="!enabledStopFromDrayage && isPortStop"
            :key="renderKey"
            :type="type"
            :drayageSearch="true"
            :isDrayage="isDrayage"
            :loadingMore="loadingPorts"
            groupKey="sectionName"
            ref="stop-input"
            :id="'location-selector' + type"
            @search="searchStop($event)"
            @selectOption="selectStop($event)"
            @blur="resetLocations"
            @handleVisibleChange="handleVisibleChange"
            @optionsEndReached="handleScrollEnd"
            v-model="stopData"
          >
            <template #icon>
              <b-icon
                icon="geo-alt"
                class="shipping-icon"
                :class="
                  type === 'delivery'
                    ? 'shipping-icon--delivery'
                    : 'shipping-icon--pickup'
                "
              />
            </template>
          </AutoComplete>
          <!-- END NEW SELECT AUTO COMPLETE -->
        </b-overlay>
      </div>
      <button
        v-if="!isPortStop"
        class="stop-selector__new-button"
        v-b-modal="'modal-new-account-stops'"
        @click="updateInfoModal"
      >
        {{ selectorButtonLabel() }}
      </button>
    </div>
    <em class="stop-selector__info">{{ inputLabelModifier(type) }}</em>
        <em
      class="stop-selector__info warning-message"
      v-if="isPortStop && missingDeliveryInfo"
    >
      Please complete the delivery information in order to enable the port field.
    </em>
    <em
      class="stop-selector__info warning-message"
      v-if="isPortStop && !missingDeliveryInfo && noPortsAvailable"
    >
      Rate might change if terminal/port of pick up and return changes.
    </em>
    <div  v-if="!isPortStop && !isDrayage" class="date-picker__wrapper">
      <ExpectedDatePicker
        v-if="type === 'pickup'"
        v-model="expectedDatePickup"
        :stopData="stopData"
        :newDate="newExpectedDate"
        ref="date-pickup"
      />
      <div class="date-picker__div-space"></div>
    </div>
    <em class="date-picker__info" v-if="type === 'pickup' && !isPortStop && !isDrayage">
      {{ $t("stopsInfo.pickupDate") }}
    </em>
    <b-modal
      v-model="showNewAccountModal"
      hide-header
      hide-footer
      size="lg"
      no-close-on-backdrop
      centered
    >
      <CreateAccountModal
        @closeModal="closeNewAccountModal"
        @updateLocations="updateLocations"
        :locationType="type"
        :infoAccountModal="newAccountModalInfo"
      />
    </b-modal>
    <b-modal
      v-model="showMagayaLocationModal"
      hide-header
      hide-footer
      size="lg"
      no-close-on-backdrop
      centered
    >
      <MagayaLocationModal
        @closeModal="showMagayaLocationModal = false"
        @updateLocations="updateLocations"
        @resetStopVariables="cancelContact"
        :locationType="type"
        :infoAccountModal="newAccountModalInfo"
      />
    </b-modal>
    <b-modal
      centered
      v-model="showSelectContactModal"
      hide-header
      hide-footer
      size="md"
      no-close-on-backdrop
    >
      <SelectContactModal
        @closeModal="closeSelectContactModal"
        @cancelSelectContact="cancelContact"
        @updateContact="selectContact"
        :contactsByAccount="contactsByAccount"
        :selectedAccount="stopData"
      />
    </b-modal>
  </div>
</template>

<script>
import { debounce } from "@/utils/Debounce";
import * as yup from "yup";
import dayjs from "dayjs";
import BuildLocationsQuery from "@/utils/LocationsQuery";
import RestrictionsFTLAndExpedited from "@/Extend/RestrictionsFTLAndExpedited";
import PortSearchHelper from "@/Extend/PortSearchHelper";
import AutoComplete from "@/components/AutoComplete.vue";
import RCSelect from "../../../../components/RCComponents/CustomRCSelect.vue";
import CreateAccountModal from "./CreateAccountModal.vue";
import MagayaLocationModal from "./MagayaLocationModal.vue";
import ValidateEmptyFields from "../../../../utils/validateEmptyFields";
import SelectContactModal from "../../shared/AccountCreation/SelectContactModal.vue";
import ExpectedDatePicker from "../../../../components/ExpectedDatePicker.vue";

export default {
  /* eslint-disable prefer-destructuring */
  /* eslint-disable implicit-arrow-linebreak */
  /* eslint-disable function-paren-newline */
  /* eslint-disable operator-linebreak */
  name: "StopSelector",
  components: {
    RCSelect,
    CreateAccountModal,
    MagayaLocationModal,
    SelectContactModal,
    ExpectedDatePicker,
    AutoComplete,
  },
  mixins: [RestrictionsFTLAndExpedited, PortSearchHelper],
  props: {
    type: String,
    stopInformation: Object,
    chosenLoad: Object,
    salesforceAccounts: Array,
    isPortStop: Boolean,
    enabledStopFromDrayage: Boolean,
    deliveryValue: Object,
    miles: Number,
    isDrayage: Boolean,
  },
  data() {
    return {
      account_id: process.env.VUE_APP_ACCOUNT_ID_TEST,
      loading: null,
      stopData: null,
      contactData: null,
      showNewAccountModal: false,
      showSelectContactModal: false,
      showMagayaLocationModal: false,
      noPortsAvailable: false,
      missingDeliveryInfo: false,
      newAccountModalInfo: null,
      copyListPorts: null,
      emptyFields: {
        stopData: false,
      },
      filteredStops: this.isDrayage && this.isPortStop ?
        [{ sectionName: '', options: [] }] :
        [
          { sectionName: "Zip Codes", options: [] },
          { sectionName: 'My Locations', options: [] },
        ],
      contactsByAccount: null,
      remountSearcher: 0,
      expectedDatePickup: null,
      newExpectedDate: null,
      locationVuexObject: null,
      countryCodes: [
        { label: "US", value: "US" },
        { label: "CA", value: "CA" },
      ],
      initialCountryCodes: [
        { label: "US", value: "US" },
        { label: "CA", value: "CA" },
      ],
      selectedCountryCode: "US",
      tokenInfo: null,
      quoteMode: null,
      loadingAutoComplete: false,
      originalPortsList: null,
      renderKey: 0,
      firstExecution: true,
      originalPostalCode: null,
      // PORTS DRAYAGE
      skip: 0,
      limit: 10,
      searchInputDrayage: "",
      debouncer: null,
      loadingPorts: false,
      allPortsWereLoaded: false,
    };
  },
  computed: {
    computedLabelPickup() {
      if (this.isDrayage) {
        return this.type === 'delivery' ? 'Pickup / Delivery Location' : 'Port / Ramp';
      }
      return this.type.charAt(0).toUpperCase() + this.type.slice(1);
    },
  },
  watch: {
    quoteMode: {
      handler() {
        this.denyCountryCodeWithQuoteMode();
        this.validateSelectedCountryCode();
      },
    },
    expectedDatePickup() {
      if (this.stopData) {
        this.stopData.expected_date = this.formatDate(
          this.expectedDatePickup.replace(/-/g, "/"),
          "YYYY-MM-DD"
        );
      }
    },
    selectedCountryCode() {
      this.$store.commit("load/stops/setCountry", { country: this.selectedCountryCode, type: this.type });
    },
    "$route.params": {
      immediate: true,
      handler() {
        this.quoteMode = this.$route.params.quoteType;
      },
    },
    miles: {
      handler: 'handlePortSearch',
      deep: true,
      immediate: true
    },
    deliveryValue: {
      handler(val) {
        if (this.isPortStop) {
          const data = val?.stopData || val;
          const hasDelivery = !!(data?.city && data?.state_code);
          // const hasDelivery = !!(val && val.city && val.state_code);
          this.missingDeliveryInfo = !hasDelivery;
          this.noPortsAvailable = false;
          if (hasDelivery) {
            this.handlePortSearch();
          } else {
            this.filteredStops[0].options = [];
            this.stopData = null;
          }
        }
      },
      deep: true,
      immediate: true
    },
    chosenLoad: {
      immediate: true,
      deep: true,
      handler() {
        if (this.stopInformation) {
          this.stopData = { ...this.stopInformation };
          this.initializeStopData(this.stopInformation);
          this.selectedCountryCode = this.stopData.country_code;
          this.renderKey += 1;
        }
      },
    }
  },
  created() {
    this.tokenInfo = this.$store.getters["login/getTokenInfo"];
    this.denyCountryCodeWithQuoteMode();
    this.debouncer = debounce(() => this.searchPortToDrayage(), 300);
    const persistInfo = JSON.parse(localStorage.getItem('stops'));
    if (this.chosenLoad || (persistInfo.length > 0 && this.stopInformation)) {
      this.stopData = { ...this.stopInformation };
      this.initializeStopData(this.stopInformation);
      this.selectedCountryCode = this.stopData.country_code;
      return;
    }
    if (this.type === "pickup" && !this.isDrayage) {
      this.newExpectedDate = new Date().toString();
      this.newExpectedDate = this.formatDate(this.newExpectedDate, "MM/DD/YYYY");
      this.newExpectedDate = this.newExpectedDate.replace(/-/g, ", ");
    }
  },
  beforeDestroy() {
    if (this.debouncer) {
      this.debouncer.cancel();
    }
  },
  methods: {
    cancelAxiosRequest() {
      this.$store.commit("triggerAbortController");
    },
    formatDate(date, type) {
      return dayjs(date).format(type);
    },
    async handleScrollEnd() {
      if (this.loadingPorts || this.allPortsWereLoaded) return;
      try {
        this.skip += this.limit;
        if (this.type === "pickup" && this.isDrayage) {
          this.loadingPorts = true;

          const morePorts = await this.searchPortToDrayage(true);
          if (!morePorts || morePorts.length === 0) {
            this.allPortsWereLoaded = true;
          }
        } else {
          const listMoreMylocations = await this.filterSalesforceAccounts(this.searchInputDrayage);
          if (!listMoreMylocations || listMoreMylocations.length === 0) {
            this.allPortsWereLoaded = true;
          } else {
            this.filteredStops[1].options = [
              ...this.filteredStops[1].options,
              ...listMoreMylocations
            ];
          }
        }
      } finally {
        this.loadingPorts = false;
      }
    },

    async handlePortSearch() {
      if (this.isDrayage && this.isPortStop && this.deliveryValue?.city && this.deliveryValue?.state_code) {
        try {
          this.loading = true;
          await this.searchPortToDrayage();
          this.focusAutocomplete();
          if (this.firstExecution) {
            this.originalPostalCode = this.filteredStops[0]?.options[0]?.postal_code;
          }
          this.stopData = this.originalPostalCode !== this.filteredStops[0].options[0].postal_code ? null : this.stopData;
        } catch (error) {
          console.error('Error searching ports:', error);
        } finally {
          this.loading = false;
          this.firstExecution = false;
        }
      }
    },
    focusAutocomplete() {
      if (!this.$route.params.loadId) {
        this.$refs["stop-input"].$refs.autocomplete.focus();
      }
    },
    initializeStopData(stopData) {
      if (!stopData) {
        return;
      }
      // Check if there is a location id in pickup or delivery and get its information
      if (stopData && stopData?.location_id) {
        const chosenAccount = this.chosenLoad.accounts.find(
          (account) => account.id === stopData?.location_id
        );
        this.stopData.city = chosenAccount.shipping_address.city;
        this.stopData.country_code = chosenAccount.shipping_address.country_code;
        this.stopData.state_code = chosenAccount.shipping_address.state_code;
        this.stopData.zip_code = chosenAccount.shipping_address.postal_code;
        this.stopData.street = chosenAccount.shipping_address.street;
        this.stopData.account_id = stopData?.location_id;
        this.stopData.id_salesforce = stopData?.location_id;
        this.stopData.name = chosenAccount.name;
        // eslint-disable-next-line max-len
        this.stopData.label = `${chosenAccount?.name}, ${chosenAccount?.shipping_address?.postal_code}`;
      } else if (stopData) {
        this.stopData = { ...stopData };
        this.stopData.label = `${stopData?.city}, ${stopData?.state_code}, ${stopData?.zip_code}`;
        this.stopData.name = "";
      }
      if (this.type === "pickup" && !this.isDrayage) {
        this.newExpectedDate = this.formatDate(
          stopData?.expected_date.replace(/-/g, "/"),
          "YYYY-MM-DD"
        );
        this.newExpectedDate = this.newExpectedDate.replace(/-/g, ", ");
      }
      // Check if there is a contact id in pickup or delivery and get its information
      if (stopData?.contact_info_id) {
        const chosenContact = this.chosenLoad.contacts.find(
          (contact) => contact.id === stopData?.contact_info_id
        );
        const newContact = {
          name: chosenContact.name,
          first_name: chosenContact.first_name,
          last_name: chosenContact.last_name,
          email: chosenContact.email,
          phone: chosenContact.phone,
        };
        this.contactData = newContact;
        // this.selectContact(chosenContact, stopsNames[i]);
      }
      const zipCodePayload = {
        type: this.type,
        zipCode: this.isDrayage && this.type === 'pickup' ?
          stopData.postal_code :
          stopData.zip_code
      };
      if (zipCodePayload.zipCode) {
        this.$store.commit("load/stops/setZipCode", zipCodePayload);
      }
      if (this.type === "pickup") {
        this.$store.commit("load/stops/setPickupStop", this.stopData);
      } else {
        this.$store.commit("load/stops/setDeliveryStop", this.stopData);
      }
    },
    async searchPortToDrayage(isLoadingMoreData = false) {
      if (!isLoadingMoreData) this.resetSearchState();

      const baseQuery = this.buildBaseQuery(this.searchInputDrayage);
      let ports = await this.fetchPorts(baseQuery);

      if (this.shouldFetchStopPort(ports)) {
        ports = await this.addStopPortIfMissing(ports, baseQuery);
      }
      ports = this.removeDuplicatesById(ports);
      this.handlePagination(ports);

      if (this.shouldMarkNoPorts(ports, isLoadingMoreData)) return;

      this.updatePortsList(ports, isLoadingMoreData);

      this.loading = false;
    },
    async searchStop(event) {
      this.skip = 0;
      this.searchInputDrayage = event.query;
      this.allPortsWereLoaded = false;
      this.loadingPorts = false;
      if (this.isDrayage && this.isPortStop) {
        await this.debouncer();
        return;
      }
      if (!event.query) {
        this.resetSearcherInfo();
      }
      this.resetContactsVuex(this.type);
      this.cancelAxiosRequest();
      const query = BuildLocationsQuery(event.query, this.selectedCountryCode);
      if (!query) {
        return;
      }
      const filteredSalesforceAccounts = await this.filterSalesforceAccounts(event.query);
      query.country_code = this.selectedCountryCode;
      const requests = [
        this.$store.dispatch("load/stops/getAllLocations", {
          params: query,
        }),
      ];
      if (query.city) {
        requests.push();
        // Comentado hasta nuevo aviso - NO BORRAR
        // this.$store.dispatch("load/stops/getMagayaClients", {
        //   params: { name: query.city },
        // })
      }
      this.loadingAutoComplete = true;
      const locations = await Promise.all(requests).then((data) => data);
      this.loadingAutoComplete = false;
      if (locations[0]) {
        this.filteredStops[0].options = this.buildStopSelectorZipCodes(locations[0]);
      }
      if (locations[1]) {
        this.filteredStops[1].options = this.buildStopSelectorLocations(locations[1]);
      }
      // Este es 2 cuando se descomente el de magaya!
      // this.filteredStops[2].options = filteredSalesforceAccounts;
      this.filteredStops[1].options = filteredSalesforceAccounts;
    },
    async filterSalesforceAccounts(query) {
      let filteredStopsAccount = [];
      if (this.$options.filters.checkPermission("get:salesforce-accounts")) {
        const response = await this.$store.dispatch("load/stops/getSalesforceAccounts", {
          params: {
            skip: this.skip,
            limit: this.limit,
            account_id: this.account_id,
            search: query,
          },
        });
        filteredStopsAccount = response;
      }
      return this.buildStopSelectorLocations(filteredStopsAccount);
    },
    buildStopSelectorZipCodes(locations, isPorts) {
      if (isPorts) {
        return locations.map((element) => ({
          ...element,
          label: `${element.name}`,
          street: `${element.address}, ${element.city}, ${element.state}, ${element.postal_code}`,
        }));
      }
      return locations.map((element) => ({
        ...element,
        label: `${element.city}, ${element.state_code}, ${element.zip_code}`,
      }));
    },
    buildStopSelectorLocations(locations) {
      return locations.map((element) => ({
        ...element,
        label: `${element.name}`,
        street: `${element.street}, ${element.city}, ${element.state_code}, ${element.zip_code}`,
      }));
    },
    removeAccents(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    async selectStop(event) {
      if (this.type === "pickup" && !this.isDrayage) {
        this.stopData.expected_date = this.formatDate(
          this.expectedDatePickup.replace(/-/g, "/"),
          "YYYY-MM-DD"
        );
      }
      const stopData = { ...event };
      this.stopData = { ...stopData };
      const zipCodePickup = this.isDrayage && this.type === 'pickup' ? this.stopData.postal_code : this.stopData.zip_code;
      if (stopData.id) {
        this.stopData.label = `${stopData.name}, ${zipCodePickup}`;
      } else {
        this.stopData.label = `${stopData.city}, ${stopData.state_code}, ${stopData.zip_code}`;
      }
      if (this.stopData.accessorials && this.stopData.accessorials.length > 0) {
        const payload = {
          id: this.stopData.id,
          type: this.type,
          accessorials: this.stopData.accessorials,
        };
        this.$store.commit("load/accessorials/setDefaultCheckedAccessorials", payload);
      }

      const zipCodePayload = {
        type: this.type,
        zipCode: zipCodePickup,
      };
      this.$store.commit("load/stops/setZipCode", zipCodePayload);

      // If user created a new salesforce account and contact
      if (event.id_salesforce) {
        if (this.$route.params.loadId) {
          this.locationVuexObject = this.buildLocationObject(event);
        }
        const paramsContactsByAccount = {
          params: {
            account_id: event.id_salesforce,
          },
        };
        if (this.$options.filters.checkPermission("get:salesforce-contacts")) {
          this.loading = true;
          this.contactsByAccount = await this.$store.dispatch(
            "load/stops/getSalesforceContactsByAccount",
            paramsContactsByAccount
          );
          this.loading = false;
        }
        // Initialize data for the select contact modal
        // Open modal to select contact
        if (!this.contactData) {
          this.showSelectContactModal = true;
        }
      } else if (event.guid) {
        if (!this.validateLocationPropsFormat(event)) {
          this.newAccountModalInfo = {
            account: this.stopData || null,
            contact: this.contactData || null,
          };
          this.showMagayaLocationModal = true;
        } else {
          await this.getContactsByMagayaClient(event.guid);
        }
      } else {
        this.stopData.location_id = null;
      }
      this.$emit("input", this.stopData);
      this.renderKey += 1;
      //! USED UNKNOWN
      /* this.remountSearcher += 1; */
    },
    validateLocationPropsFormat(location) {
      const contactSchema = yup.object().shape({
        name: yup.string().required(),
        city: yup.string().required(),
        country_code: yup.string().required(),
        state_code: yup.string().required(),
        street: yup.string().required(),
        zip_code: yup.string().required(),
      });
      const isValid = contactSchema.isValidSync(location, {
        abortEarly: false,
      });
      return isValid;
    },
    async getContactsByMagayaClient(guid) {
      this.loading = true;
      this.contactsByAccount = await this.$store.dispatch(
        "load/stops/getContactsByMagayaClient",
        {
          params: { guid },
        }
      );
      this.loading = false;
      if (!this.contactData) {
        this.showSelectContactModal = true;
      }
    },
    buildLocationObject(payload) {
      return {
        id: payload.id_salesforce,
        name: payload.name.toUpperCase(),
        shipping_address: {
          city: payload.city,
          country_code: payload.country_code,
          postal_code: payload.zip_code,
          state_code: payload.state_code,
          street: payload.street,
        },
      };
    },
    buildContactObject(payload) {
      return {
        id: payload.id,
        name: payload.name,
        first_name: payload.first_name,
        last_name: payload.last_name,
        phone: payload.phone,
        email: payload.email,
        last_referenced_date: payload.last_referenced_date,
      };
    },
    validateQuery(query) {
      const wordsRegexp = new RegExp(/^[^0-9,\n]+(?:,[^0-9,\n]+){0,1}$/);
      const numberRegexp = new RegExp(/\d/g);
      const wordsTest = wordsRegexp.test(query);
      const numbersTest = numberRegexp.test(query);
      if ((wordsTest || numbersTest) && query.length >= 3) {
        return true;
      }
      return false;
    },
    resetLocations() {
      this.newAccountModalInfo = null;
      this.selectedAccount = null;
      if (this.type === "pickup" && !this.stopData) {
        this.$store.commit("load/stops/setPickupStop", null);
        const zipCodePayload = {
          type: this.type,
          zipCode: null,
        };
        this.$store.commit("load/stops/setZipCode", zipCodePayload);
        this.resetContactsVuex(this.type);
      }
      if (this.type === "delivery" && !this.stopData) {
        this.$store.commit("load/stops/setDeliveryStop", null);
        const zipCodePayload = {
          type: this.type,
          zipCode: null,
        };
        this.$store.commit("load/stops/setZipCode", zipCodePayload);
        this.resetContactsVuex(this.type);
      }
      if (!this.stopData) {
        this.resetSearcherInfo();
      }
    },
    handleVisibleChange() {
      if (!this.stopData) {
        this.searchStop({ query: '', originEvent: '' });
      }
    },
    resetSearcherInfo() {
      this.stopData = null;
      this.contactData = null;
      this.filteredStops = this.isDrayage && this.isPortStop ?
        [{ options: [] }] :
        [
          { sectionName: "Zip Codes", options: [] },
          { sectionName: "My Locations", options: [] },
        ];
      this.remountSearcher += 1;
      this.noPortsAvailable = false;
      this.missingDeliveryInfo = false;
    },
    updateLocations(newLocationsData) {
      this.stopData = { ...newLocationsData.account };
      this.selectContact(newLocationsData.contact);
      this.selectStop(newLocationsData.account);
    },
    selectContact(event) {
      if (this.$route.params.loadId) {
        this.$store.commit("load/setLocationToLoad", this.locationVuexObject);
        this.$store.commit("load/setContactToLoad", this.buildContactObject(event));
      }
      const concatenatedContactLabel = `${event.first_name}, ${event.last_name}`;
      this.contactData = { ...event };
      this.contactData.name = event.first_name
        ? `${event.first_name} ${event.last_name}`
        : event.last_name;
      this.contactData.label = concatenatedContactLabel;
      this.$store.commit("load/stops/setContact", {
        type: this.type,
        contact: { ...this.contactData },
      });
      if (event.guid) {
        this.stopData.location_id = event.id_salesforce;
        this.stopData.id_salesforce = event.id_salesforce;
        this.stopData.contact_info_id = event.id;
        this.stopData.id = event.db_account_id;
        this.stopData.account_id = process.env.VUE_APP_ACCOUNT_ID_TEST;
      }
      this.setStopInfoInVuex();
    },
    updateInfoModal() {
      this.newAccountModalInfo = {
        account: this.stopData || null,
        contact: this.contactData || null,
      };
      this.showNewAccountModal = true;
    },
    closeNewAccountModal() {
      this.newAccountModalInfo = null;
      this.showNewAccountModal = false;
    },
    closeSelectContactModal() {
      this.showSelectContactModal = false;
    },
    cancelContact() {
      this.contactData = null;
      this.stopData = null;
      this.expectedDatePickup = new Date();
      this.expectedDatePickup = this.formatDate(this.expectedDatePickup, "YYYY-MM-DD");
      const zipCodePayload = {
        type: this.type,
        zipCode: null,
      };
      this.$store.commit("load/stops/setZipCode", zipCodePayload);
      this.showSelectContactModal = false;
      this.resetLocations();
      this.remountSearcher += 1;
    },
    resetContactsVuex(type) {
      const data = {
        contact: null,
        type,
      };
      this.contactData = null;
      this.$store.commit("load/stops/setContact", data);
    },
    setStopInfoInVuex() {
      const params = {
        ...this.stopData,
        name: this.type.charAt(0).toUpperCase() + this.type.slice(1),
        related_name: this.type,
        is_dropoff: this.type !== "pickup",
        is_pickup: this.type === "pickup",
        number: this.type === "pickup" ? 0 : 1,
      };
      if (this.stopData.id_salesforce) {
        params.location_id = this.stopData.id_salesforce;
        params.contact_info_id = this.contactData
          ? this.contactData.id || this.stopInformation.contact_info_id
          : null;
      }
      if (this.type === "pickup") {
        this.$store.commit("load/stops/setPickupStop", params);
      } else {
        this.$store.commit("load/stops/setDeliveryStop", params);
      }
    },
    validateExpectedDate() {
      const validation = this.$refs["date-pickup"].validateExpectedDate();
      return validation;
    },
    // Form validation
    validateFormfields() {
      const validatedForm = ValidateEmptyFields({ stopData: this.stopData });
      this.resetEmptyFieldsValues();
      validatedForm.emptyFields.forEach((field) => {
        this.emptyFields[field] = true;
      });
      if (validatedForm.validation) {
        if (this.type === "pickup" && !this.isDrayage) {
        // Solo validar expected date si no es drayage
          const dateValidation = this.validateExpectedDate();
          if (!dateValidation) return false;
        }
        this.setStopInfoInVuex();
        this.$emit("input", { stopData: this.stopData });
      }
      return validatedForm.validation;
    },
    resetEmptyFieldsValues() {
      const keys = Object.keys(this.emptyFields);
      keys.forEach((key) => {
        this.emptyFields[key] = false;
      });
    },
    handleMissingStyles(value, attribute) {
      if (value) {
        this.emptyFields[attribute] = false;
      } else {
        this.emptyFields[attribute] = true;
      }
    },
    inputLabelModifier() {
      let text = '';
      let newLabel = '';
      if (this.isDrayage) {
        text = this.type === 'delivery' ? 'Pickup / Delivery Location' : 'Port / Ramp';
        newLabel = this.type === 'delivery' ? `${text} Zip Code or Location Name ` : `${text} Zip Code or Name `;
      } else {
        text = this.type.charAt(0).toUpperCase() + this.type.slice(1);
        newLabel = `${text} Zip Code or Location Name `;
      }
      return newLabel;
    },
    selectorButtonLabel() {
      let buttonLabel = null;
      if (this.type === "pickup") {
        buttonLabel = this.$t("stopsInfo.originDetails");
      } else if (this.type !== "pickup" && this.isDrayage) {
        buttonLabel = this.$t("stopsInfo.defaultDetails");
      } else {
        buttonLabel = this.$t("stopsInfo.deliveryDetails");
      }
      return buttonLabel;
    },
    validateSelectedCountryCode() {
      const isValidCountryCode = this.countryCodes.some(
        (country) => country.value === this.selectedCountryCode
      );
      if (!isValidCountryCode) {
        this.stopData = null;
      }
    },
    denyCountryCodeWithQuoteMode() {
      if (this.quoteMode === "ftl") {
        this.countryCodes = this.countryCodes.filter((country) => country.value !== "MX");
        return;
      }
      if (this.quoteMode === "expedited") {
        this.countryCodes = this.countryCodes.filter((country) => country.value === "US");
        return;
      }
      if (this.quoteMode === "ltl" || this.quoteMode === "all-options") {
        this.countryCodes = [
          { label: "US", value: "US" },
          { label: "CA", value: "CA" },
          { label: "MX", value: "MX" },
        ];
      } else {
        this.countryCodes = [...this.initialCountryCodes];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../../../assets/scss/components/Modal.scss";
@use "../../../../assets/scss/components/RCComponents.scss";
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;
@use '@/assets/scss/buttons/_buttons' as *;
@use '@/assets/scss/_extend' as *;

.location-selector-container {
  display: grid;
  grid-template-columns: 70px 1fr;
  justify-content: space-between;
  width: 100%;
}

.stop-selector {
  width: 100%;
  &__searcher {
    width: 100% !important;
    display: flex;
    flex-direction: row;
    &--margin {
      margin-top: 3%;
    }
  }
  &__section-title {
    margin: 15px 0px 5px 15px;
    text-align: left;
    color: $color-border-container;
  }
  &__suggestions {
    margin-left: 5px;
    margin-bottom: 5px;
    color: $color-primary-company;
  }
  &__country {
    max-width: 64px;
    margin-right: 5px;
    // border: 1px solid $color-border-container !important;
    @media (max-width: 500px) {
      width: 100%;
    }
  }
  & .search-input {
    border: 1px solid $color-border-container;
  }
  &__column {
    width: 100%;
    @media (max-width: 560px) {
      margin-top: 3%;
    }
  }
  &__new-button {
    @include primary-button($heightSize: 40px);
    @extend %flex-center-center;
    @include font-button-text;
    padding: 5px 5px;
    width: 175px;
    margin: 0px 10px 0px 10px;
    border-radius: 15px;
    font-size: 14px;
    font-weight: 400;
    &:disabled {
      background-color: rgba(177, 177, 177, 0.774);
      &:hover {
        background-color: rgba(177, 177, 177, 0.774);
      }
    }
  }
  &__spinner {
    width: 100%;
  }
  &__info {
    font-weight: 400;
    font-size: 12px;
    margin: 3px 0 0 5px;
    text-align: left;
    display: flex;
    justify-content: left;
  }
}
.date-picker {
  &__div-space {
    width: 170px;
    margin: 0 10px;
  }
  &__wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  &__info {
    font-weight: 400;
    font-size: 12px;
    margin-left: 10px;
    display: flex;
    justify-content: flex-start;
  }
}

.address-text {
  color: rgb(180, 177, 177);
}

.warning-message {
  color: red;
}

.disabled {
  pointer-events: none;
}

///**** styles for icon inside the input****\\\\
.shipping-icon {
  font-size: 1.3rem;
  vertical-align: -6px;
  &--pickup {
    color: $color-primary-company;
  }
  &--delivery {
    color: $color-blue-hover;
  }
}

.required-field {
  color: $color-error;
}

::v-deep .dropdown__option {
  margin: 0 15px;
}

@media (max-width: 560px) {
  .stop-selector:not(:first-child) {
    margin-top: 5%;
  }
}
@media (max-width: 330px) {
  .stop-selector:not(:first-child) {
    margin-top: 5%;
  }
}
// Date picker styles
::v-deep .el-input__inner {
  height: 35px;
  border-radius: 10px;
  border: 1px solid $color-border-container;
  line-height: unset;
  text-align: left;
  color: $color-text-general;
}
::v-deep .el-input--suffix .el-input__inner {
  padding-right: 0;
}
::v-deep .el-input__prefix {
  color: $color-shadow-sidebar;
  top: -2px;
}

::v-deep .modal-content {
  width: 100%;
  @media (max-width: 500px) {
    width: 60%;
  }
}

::v-deep .dropdown-container {
  &__selected-option {
    height: 100% !important;
  }
}

::v-deep .autocomplete__label {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  text-align: start;
}

::v-deep  .el-input--prefix .el-input__inner {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
</style>
